export default __webpack_public_path__ + "static/media/box.1f8d185f.svg";